import { cn } from '@/shared/lib/cn';
import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import { Typography } from './typography';

type RadioProps = {
  label?: string;
  placement?: 'radio-label' | 'label-radio';
  fullWidth?: boolean;
} & ComponentPropsWithoutRef<'input'>;

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  (
    {
      fullWidth = false,
      disabled = false,
      placement = 'radio-label',
      label,
      className,
      ...props
    },
    ref
  ) => {
    return (
      <label
        className={cn(
          'flex cursor-pointer items-center gap-2',
          placement === 'label-radio' && 'flex-row-reverse',
          fullWidth && 'w-full justify-between',
          disabled && 'cursor-not-allowed',
          className
        )}
      >
        <input
          type="radio"
          className="bg-primary-6 border-neutral-5 disabled:bg-neutral-3 h-4 w-4 cursor-pointer rounded-full focus:ring-blue-500 disabled:cursor-not-allowed"
          ref={ref}
          disabled={disabled}
          {...props}
        />
        {label && (
          <Typography className={cn('select-none', disabled && 'opacity-50')}>
            {label}
          </Typography>
        )}
      </label>
    );
  }
);

Radio.displayName = 'Radio';
